<!-- Trip Modal -->
<div class="modal fade" id="tripModal" tabindex="-1" role="dialog" aria-labelledby="tripModalLabel" aria-hidden="true"
    style="z-index: 100000;">

    <div class="modal-dialog modal-dialog-centered modal-xl" role="document">

        <div class="modal-content dirI">

            <div class="modal-header">

                <h5 class="modal-title" id="tripModalLabel"> ثبت سفر </h5>

                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>

            </div>

            <div class="modal-body">

                <ng-container *ngIf="isOpen">

                    <app-trips [appMenuType]="-1" (tripModal_Close)="closed.emit()"> </app-trips>

                </ng-container>

            </div>

        </div>

    </div>

</div>
